import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars } from '@fortawesome/free-solid-svg-icons';

library.add(faBars);

const BurgerIcon = () => (
  <>
    <p className="d-inline-block mb-0 pr-2">MENU</p>
    {' '}
    <FontAwesomeIcon icon="bars" />
  </>
);

export default BurgerIcon;
